module.exports = __webpack_public_path__ + "static/john-robbins-outdoor-ad.d8f799fb.jpg";